import { render } from "./CommentReplyForm.vue?vue&type=template&id=0258dac9"
import script from "./CommentReplyForm.vue?vue&type=script&lang=js"
export * from "./CommentReplyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__